import { useState } from 'react';
import { useMedia } from 'react-use';

import Checkbox from 'react-scale/components/tailwind/Form/Checkbox';
import { useToggleState } from 'react-scale/hooks/use-toggle-state';

import GradientButton from 'components/pages/transformx/common/gradient-button';
import MobileFilters from './mobile-filters';

import s from './filters.module.css';

const FiltersSvg = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M29.3337 6.66663H2.66699L13.3337 19.28V28L18.667 30.6666V19.28L29.3337 6.66663Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MobileFiltersButton = props => {
  const mobileFiltersState = useToggleState();

  return (
    <>
      <GradientButton
        onClick={mobileFiltersState.handleToggle}
        hoverless
        className="!fixed z-20 block bg-black rounded-full lg:hidden bottom-6 right-6 !w-14 !h-14"
      >
        <div className="absolute inset-0 flex items-center justify-center">
          <FiltersSvg />
        </div>
      </GradientButton>
      <MobileFilters {...mobileFiltersState} {...props} />
    </>
  );
};

export const FilterName = ({ label = '' }) => {
  const isMobile = useMedia('(max-width: 1023px)');

  return isMobile ? (
    <>
      <p className="mb-2 text-lg capitalize">{label}</p>
      <div className="bg-gradient-x w-full h-[1px] mb-4" />
    </>
  ) : (
    <p className="mb-4 leading-8 text-neutral-400 capitalize">{label}</p>
  );
};

export const FilterItem = ({
  label = '',
  value = undefined,
  type = undefined,
  counter = '',
  checked = false,
  children,
  onClick = () => null
}) => {
  const isMobile = useMedia('(max-width: 1023px)');

  return isMobile ? (
    <div className={s.filterItem}>
      <div className="flex justify-between h-6 w-full">
        <div className="flex justify-between w-full overflow-hidden">
          <p className="text-sm leading-6 whitespace-nowrap overflow-hidden text-ellipsis">
            {label}
          </p>
          {counter && <p className="text-scale-lightmauve text-sm mr-4">{`(${counter})`}</p>}
        </div>
        <Checkbox onChange={() => onClick(type, value)} checked={checked} size="lg" />
      </div>
      <div className="w-full h-[1px] bg-[#444444] mt-4" />
    </div>
  ) : (
    <div className={s.filterItem}>
      <Checkbox onChange={() => onClick(type, value)} checked={checked} theme="dark">
        {children}
        <p className={s.filterText}>{label}</p>
        {counter && <p className="text-scale-lightmauve text-sm ml-2">{`(${counter})`}</p>}
      </Checkbox>
    </div>
  );
};

export const FilterBox = ({ bg, children, resetFilters }) => (
  <>
    <div className={`${bg} ${s.filterBox}`}>
      <div className="h-full">{children}</div>
    </div>
    <MobileFiltersButton resetFilters={resetFilters}>{children}</MobileFiltersButton>
  </>
);

const Filters = ({ initialValues, children }) => {
  const [filters, setFilters] = useState(initialValues ?? {});

  const resetFilters = () => {
    const clearedFilters = Object.keys(initialValues).reduce(
      (acum, current) => ({ ...acum, [current]: [] }),
      {}
    );
    setFilters(clearedFilters);
  };

  const toggleFilter = (type, filter) =>
    setFilters(prevFilters => {
      const newFilters = [...prevFilters[type]];

      if (newFilters.includes(filter)) {
        newFilters.splice(newFilters.indexOf(filter), 1);
      } else {
        newFilters.push(filter);
      }

      return { ...prevFilters, [type]: newFilters };
    });

  return children({
    filters,
    onClick: toggleFilter,
    resetFilters
  });
};

export default Filters;
